import React from 'react';
import './PaymentStatus.css'; // Import the CSS file

const PaymentStatus = ({ isSuccess, message }) => {
  return (
    <>
      {isSuccess ? (
        <div className="message-box _success">
          <i className="fa fa-check-circle" aria-hidden="true"></i>
          <h2>Your payment was successful</h2>
          <p>
            Thank you for your payment. We will <br />
            be in contact with more details shortly
          </p>
        </div>
      ) : (
        <div className="message-box _success _failed">
          <i className="fa fa-times-circle" aria-hidden="true"></i>
          <h2>Your payment failed</h2>
          <p>{message || "Try again later"}</p>
        </div>
      )}
    </>
  );
};

export default PaymentStatus;
